import styled from 'styled-components';
import { theme } from '../../styles/theme';

// Reaproveita a linguagem visual do input_v2: label flutuante sobre a borda,
// borda #bac1cf, raio 8px, Lato 14px.
export const Container = styled.div`
  width: ${props => props.width || '100%'};
  min-height: ${props => props.minHeight || '70px'};
  margin-bottom: ${props => props.marginBottom || '25px'};
  margin-top: ${props => props.marginTop || '0px'};
  position: relative;
  z-index: 3;
`;

export const Label = styled.label`
  width: auto;
  height: 3px;
  padding: 0 4px;
  background-color: ${props => (props.isFloating ? '#FFF' : 'transparent')};

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;

  margin-bottom: 0px;
  margin-left: 14px;
  margin-top: ${props => (props.isFloating ? '-2px' : '24px')};

  font-family: Lato;
  font-size: 14px;
  font-weight: 400;

  position: absolute;
  z-index: 1;
  border-radius: 65px;
  transition: all 0.3s;

  color: ${props =>
    props.erro
      ? theme.colors.red.Vermelho_erro
      : props.disabled
        ? theme.colors.disabled.Desabilitado_Claro
        : theme.colors.gray.Cinza_6};

  > b {
    color: ${theme.colors.red.Vermelho_erro};
  }

  &:hover {
    cursor: ${props => (props.isFloating ? 'context-menu' : 'text')};
  }

  @media only screen and (max-width: 540px) {
    margin-left: 12px;
  }
`;

export const Control = styled.div`
  width: 100%;
  /* 56px fechado e aberto. Com box-sizing: border-box (global), fechado a badge
     de 24px + 24 de padding + 2 de borda davam 50px, e aberto o input de 30px
     levava para 56 - o campo pulava ao abrir o menu. */
  min-height: 56px;
  padding: 12px 40px 12px 25px;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  background-color: ${props =>
    props.disabled ? theme.colors.disabled.Fundo_Desabilitado : theme.colors.white.Branco};
  border: solid 1px
    ${props =>
      props.erro
        ? theme.colors.red.Vermelho_erro
        : props.disabled
          ? '#cfd5df'
          : theme.colors.gray.Cinza_8};
  border-radius: 8px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'text')};
  position: relative;
`;

/* Envolve o Badge (importado no index.js) so para limitar a largura: nome
   comprido nao pode empurrar o X nem esticar o campo. O filho direto e o
   BadgeContainer, que e um div. */
export const BadgeSlot = styled.div`
  min-width: 0;
  max-width: 100%;
  flex: ${props => (props.grow ? '1 1 auto' : '0 1 auto')};
  display: inline-flex;

  > div > p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SearchInput = styled.input`
  flex: 1 1 60px;
  min-width: 60px;
  height: 30px;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;

  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: ${theme.colors.gray.Cinza_5};

  /* Tipografia do placeholder igual a do InputV3 (styles_v3.js, S.Placeholder):
     12px / 400 / 18px em Cinza_7. Sem estas linhas ele herdava os 16px em bold
     do texto digitado, que e a regra do valor, nao do placeholder. */
  &::placeholder {
    color: ${theme.colors.gray.Cinza_7};
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.125rem;
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const Caret = styled.span`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%) rotate(${props => (props.isOpen ? '180deg' : '0deg')});

  line-height: 1;
  pointer-events: none;
  transition: transform 0.2s ease;

  > img {
    width: 16px;
    height: auto;
    display: block;
  }
`;

export const Menu = styled.div`
  width: 100%;
  max-height: 260px;
  overflow-y: auto;

  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  /* Acima da barra de rolagem falsa da TableWithLabelBlackV2 (z-index 4) e de
     outros inputs da mesma coluna. */
  z-index: 20;

  background-color: ${theme.colors.white.Branco};
  border: solid 1px ${theme.colors.gray.Cinza_10};
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(33, 38, 47, 0.12);
  padding: 6px;
`;

export const MenuHint = styled.p`
  margin: 0;
  padding: 6px 10px;

  font-family: Lato;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.gray.Cinza_2};
`;

export const Option = styled.div`
  width: 100%;
  padding: 7px 8px;

  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: 6px;
  cursor: pointer;
  /* O realce de mouse fica no :hover do CSS, nao em estado do React: com
     onMouseEnter o cinza grudava na linha depois que o ponteiro saia, porque
     nada desfazia o highlight. O isHighlighted cobre so a navegacao por teclado. */
  background-color: ${props => (props.isHighlighted ? theme.colors.gray.Cinza_12 : 'transparent')};

  &:hover {
    background-color: ${theme.colors.gray.Cinza_12};
  }

  font-family: Lato;
  font-size: 14px;
  color: ${theme.colors.gray.Cinza_5};

  > .acoes {
    flex: 0 0 auto;
    display: flex;
    gap: 2px;
    opacity: ${props => (props.isHighlighted ? 1 : 0)};
    transition: opacity 0.15s ease;
  }

  &:hover > .acoes {
    opacity: 1;
  }
`;

export const IconButton = styled.button`
  width: 28px;
  height: 28px;
  padding: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 4px;
  background: transparent;
  color: ${props => (props.danger ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7)};
  font-size: 12px;
  cursor: pointer;

  > img {
    width: 20px;
    height: 20px;
    display: block;
  }
`;

// Ao contrario das opcoes existentes, esta linha nao recebe o realce cinza: o
// container fica branco e quem sinaliza a acao e o botao verde.
export const CreateRow = styled(Option)`
  background-color: ${theme.colors.white.Branco};
  cursor: default;

  /* Ver comentario acima: encolhe o padding interno do ButtonV2 para a altura
     de 30px usada no dropdown, senao o conteudo estoura e sai do centro. */
  .btnv2 {
    padding: 0 16px;
  }


  &:hover {
    background-color: ${theme.colors.white.Branco};
  }
`;

export const EditRow = styled.div`
  width: 100%;
  padding: 4px 8px;

  /* Ver comentario acima: encolhe o padding interno do ButtonV2 para a altura
     de 30px usada no dropdown, senao o conteudo estoura e sai do centro. */
  .btnv2 {
    padding: 0 16px;
  }

  display: flex;
  align-items: center;
  /* Os botoes Salvar/Cancelar ocupam bem mais que os icones anteriores: em campo
     estreito eles descem para a linha de baixo em vez de espremer o input. */
  flex-wrap: wrap;
  gap: 6px;

  > input {
    flex: 1 1 120px;
    min-width: 0;
    height: 32px;
    padding: 0 8px;
    border: solid 1px ${theme.colors.gray.Cinza_8};
    border-radius: 6px;
    outline: none;

    font-family: Lato;
    font-size: 14px;
    color: ${theme.colors.gray.Cinza_5};
  }
`;

// Ocupa o lugar dos botoes enquanto a rota roda. Fica sempre visivel, ao
// contrario de .acoes, que so aparece no hover.
export const AcoesLoading = styled.span`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

export const StateRow = styled.p`
  margin: 0;
  padding: 10px;
  text-align: center;

  font-family: Lato;
  font-size: 14px;
  color: ${props => (props.erro ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7)};
`;

export const Legenda = styled.p`
  margin: 4px 0 0 14px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 400;
  color: ${props => (props.erro ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7)};
`;
